import React from "react";
import { Alert, AlertColor } from "@mui/material";
import { makeStyles } from "@mui/styles";

type TCustomAlertMessageProps = {
	varient: AlertColor;
	label: string;
	description: string;
};

const customAlertStyle = makeStyles((theme: any) => ({
	alertStyle: {
		fontSize: "1rem",
		margin: "1rem 0rem",
		borderRadius: "0.7rem",
		textAlign: "justify",
		padding: "0rem 1rem"
	},
	disclaimerMessage: {
		"& strong.disclaimer": {
			fontWeight: "bold"
		}
	}
}));

const CustomAlertMessage: React.FC<TCustomAlertMessageProps> = ({ varient, label, description }): JSX.Element => {
	const styleClass = customAlertStyle();

	return (
		<Alert severity={varient} className={styleClass.alertStyle}>
			<div className={styleClass.disclaimerMessage}>
				<strong className="disclaimer">{label}: </strong>
				<span>{description}</span>
			</div>
		</Alert>
	);
};

export default CustomAlertMessage;
